export enum ERoleType {
  spencerAdmin = 'spencerAdmin',
  schoolAdmin = 'schoolAdmin',
  needManager = 'needManager',
  professional = 'professional'
}

export enum ESchoolType {
  INDEPENDENT = 'Independent',
  NURSERY = 'Nursery',
  INFANT = 'Infant',
  JUNIOR = 'Junior',
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
  ALL_THROUGH = 'All Through',
  FE_PROVISION = 'FE Provision',
  SEND_SCHOOL = 'SEND School',
  ALTERNATIVE_PROVISION = 'Alternative Provision'
}

export enum ESortOptions {
  asc = 'asc',
  desc = 'desc'
}

export enum EQuestionnaireStatus {
  Complete = 'Complete',
  Incomplete = 'Incomplete',
  'In progress' = 'In progress'
}

export enum ERequestStatus {
  'created' = 'Request sent',
  'approved' = 'Request approved',
  'rejected' = 'Request rejected',
}

export enum ERequestBageType {
  'approved' = 'success',
  'rejected' = 'danger'
}

export enum EAnswerOptions {
  Always = '0',
  'Very Often' = '1',
  Sometimes = '2',
  Rarely = '3',
  Never = '4'
}

export enum EStudentProfilePage {
  comparison = 'comparison',
  analysis = 'analysis'
}

export enum EChartColors {
  PieHighSeverity = '#3B5781',
  PieMediumSeverity = '#E67411',
  PieLowSeverity = '#1CA39B',
  Bar = '#6995BA',
  ComparisonBar = '#D2DFEA'
}
